export default __webpack_public_path__ + "static/media/warning.6c87a9f4.svg";